/**
 * Vuex Store Index
 *
 * Central Vuex store configuration that aggregates all store modules.
 */

import Vue from 'vue';
import Vuex from 'vuex';
import featureFlags from './modules/featureFlags';
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    featureFlags,
    user
  },
  strict: process.env.NODE_ENV !== 'production'
});